export const core = {
    common: {
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        add: 'Add',
        search: 'Search',
        loading: 'Loading...',
        success: 'Success',
        error: 'Error',
        confirm: 'Confirm',
        close: 'Close',
        view: 'View',
        back: 'Back',
        next: 'Next',
        previous: 'Previous',
        submit: 'Submit',
        refresh: 'Refresh',
        filter: 'Filter',
        export: 'Export',
        import: 'Import',
        download: 'Download',
        upload: 'Upload',
        actions: 'Actions',
        status: 'Status',
        date: 'Date',
        total: 'Total',
        subtotal: 'Subtotal',
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        address: 'Address',
        description: 'Description',
        notes: 'Notes',
        settings: 'Settings',
        logout: 'Logout',
        login: 'Login',
        register: 'Register',
        yes: 'Yes',
        no: 'No',
        all: 'All',
        active: 'Active',
        inactive: 'Inactive',
    },
    sidebar: {
        dashboard: 'Dashboard',
        orders: 'Orders',
        customers: 'Customers',
        forms: 'Forms',
        abandonedCarts: 'Abandoned Carts',
        adReports: 'Ad Reports',
        csReports: 'CS Reports',
        cuanRank: 'Cuan Rank',
        settings: 'Settings',
        myProfile: 'My Profile',
        earnings: 'Earnings',
    },
    header: {
        notifications: 'Notifications',
        profile: 'Profile',
        darkMode: 'Dark Mode',
        lightMode: 'Light Mode',
        language: 'Language',
    },
    dashboard: {
        title: 'Dashboard',
        totalRevenue: 'Total Revenue',
        totalOrders: 'Total Orders',
        totalCustomers: 'Total Customers',
        conversionRate: 'Conversion Rate',
        recentOrders: 'Recent Orders',
        topProducts: 'Top Products',
        revenueChart: 'Revenue Chart',
        ordersChart: 'Orders Chart',
        viewAll: 'View All',
    },
};
